export enum CommentType {
  ASSESSMENT = 'ASSESSMENT'
}
